import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import { withPlugin } from '@core/hoc/withPlugin'
import { routeChange, setModal, getOrganization } from '@app/ac'

const mapStateToProps = ({
  auth,
  me,
  loading,
  workspaceId,
  workspaces,
  organization,
  organizationId,
  calendar
}) => {
  const workspace = workspaces?.find(w => w.id === workspaceId)
  const isOrgOwner = Boolean(organizationId && me?.acl?.organizations && Object.keys(me.acl.organizations).includes(organizationId) && me.acl.organizations[organizationId].includes('organization_owner'))

  return {
    auth,
    me,
    isLoading:
      loading.includes('first-load') ||
      loading.includes('me') ||
      loading.includes('workspace-switch') ||
      loading.includes('workspace-detail') ||
      loading.includes('set-organization-id') ||
      loading.includes('set-org'),
    isLoadingOrganization: loading.includes('set-org'),
    subscription: organization?.settings?.billing,
    organization,
    workspaceId,
    workspace,
    calendarDate: calendar?.date || window.localStorage.getItem('ds-calendar-store'),
    calendarView: calendar?.view || window.localStorage.getItem('ds-calendar-view'),
    isOrgOwner
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setModal,
    routeChange,
    getOrganization
  }, dispatch)
}

export default (component) => {
  return compose(
    withPlugin,
    connect(mapStateToProps, mapDispatchToProps)
  )(component)
}
